import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarHiddenRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSidebarHiddenRightWide"><Path d="M2.5 4.5H21.5V19.5H2.5V4.5Z" stroke="currentColor"/><Path d="M18.5 7V17" stroke="currentColor"/></CentralIconBase>;
});

export default IconSidebarHiddenRightWide;
